// extracted by mini-css-extract-plugin
module.exports = {"selectedBlue":"#1872bc","backgroundLightGray":"#e5e5e5","error":"#f14668","white":"#fff"};